import { newSize, newVector, fallbackCopy, newTextPinComponent, newAnswerAreaPinComponent } from '../helpers';
import { SortingQuestionPinLayoutTemplate } from '../models';
import { stringToProsemirror } from '../tip-tap';

export function sortingQuestionTitleOnlyLayout({
  question = fallbackCopy['openQuestion.title'],
  backgroundColor,
  backgroundImage,
}: {
  question?: string;
  backgroundColor?: string;
  backgroundImage?: string;
}): SortingQuestionPinLayoutTemplate {
  return {
    key: 'TITLE_ONLY',
    backgroundColor,
    backgroundImage,
    layoutParts: {
      TITLE: newTextPinComponent({
        position: newVector(32, 32),
        size: newSize(896, 60),
        content: stringToProsemirror(question, {
          bold: true,
        }),
        order: 'a0',
        settings: {
          typographyKey: 'headline',
          textStyleKey: 'TITLE',
          horizontalAlignment: 'center',
        },
      }),
      ANSWER_AREA: newAnswerAreaPinComponent({
        order: 'a1',
      }),
    },
    pinComponents: [],
  };
}
